import { gql } from '@apollo/client';

export const CORE_USER_FIELDS = gql`
  fragment CoreUserFields on User {
    id
    firstName
    lastName
    bun
  }
`;

export const GET_APP_USER = gql`
  ${CORE_USER_FIELDS}
  query AppUser {
    appUser {
      ...CoreUserFields
      etrackId
      roles {
        id
        description
        name
      }
      projects {
        id
        name
        isActive
      }
    }
  }
`;

// TODO: Filter users based on role
export const SEARCH_USERS = gql`
  ${CORE_USER_FIELDS}
  query SearchUsers($searchTerm: String!, $cursorPaginationInput: CursorPaginationInput!) {
    searchUsers(searchTerm: $searchTerm, cursorPaginationInput: $cursorPaginationInput) {
      cursor
      items {
        ...CoreUserFields
        etrackId
        roles {
          id
          description
          name
        }
        projects {
          id
          name
          isActive
        }
      }
    }
  }
`;

export const SEARCH_USERS_PROJECTS = gql`
  query SearchUserProjects($searchInput: SearchInput) {
    searchUserProjects(searchInput: $searchInput) {
      items {
        firstName
        lastName
        id
        email
        lobEmployeeId
        toolHoundId
        isActive
        user {
          bun
          id
        }
        persona
        imageUrl
        supervisor {
          id
        }
      }
    }
  }
`;
